import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import PortfolioV1v from './section-components/portfolio-v1v';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import { useLang } from '../i18n/LanguageContext';

const Portfolio_V1 = () => {
    const { t } = useLang();
    return <div>
        <Navbar />
        <PageHeader headertitle={t('pageTitles.videos')} subheader={t('pageTitles.videos')} />
        <PortfolioV1v />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Portfolio_V1
